import { Component } from "react";
import "./App.css";
import NewsList from "./Components/NewsList/NewsList";

class App extends Component {


  render() {

    return (
      <div className="App">
        <NewsList/>
      </div>
    );
  }
}

export default App;
